module.exports = __webpack_public_path__ + "img/celine-dion_encore-un-soir.9c217a5d.jpg";